import React from "react";

import { PlatformTeamRow } from "../../common/platformTypes";
import { BoolCheck } from "../../components/BoolCheck";
import { Date as DateView } from "../../components/Date";
import { PlatformUserLink, TeamLink } from "../../components/DocumentLink";
import {
  DocumentTable,
  DocumentTableProperty,
} from "../../components/DocumentTable";
import { PagedListPage } from "../../components/PagedListPage";
import { listTeams } from "../../services/api/Platform";

const PROPERTIES: DocumentTableProperty<PlatformTeamRow>[] = [
  {
    title: "Name",
    render: (d) => <TeamLink docId={d._id}>{d.name}</TeamLink>,
    style: { maxWidth: "28%" },
  },
  { title: "Type", render: (d) => d.type },
  {
    title: "Tier",
    render: (d) => d.tier ?? <span className="text-muted">—</span>,
  },
  { title: "Members", render: (d) => d.memberCount },
  {
    title: "Created By",
    // Scoped by team: the fixture creators repeat across rows, and DocumentLink
    // builds its tooltip target from the id alone.
    render: (d) => (
      <PlatformUserLink docId={d.createdBy} scope={d._id}>
        {d.createdByName ?? d.createdBy}
      </PlatformUserLink>
    ),
  },
  {
    title: "Created",
    render: (d) => <DateView date={new Date(d.createdAt)} />,
  },
  {
    title: "Active Sub",
    render: (d) => <BoolCheck check={d.hasActiveSubscription} />,
  },
];

export const TeamsPage: React.FunctionComponent = () => (
  <PagedListPage<PlatformTeamRow>
    title="Teams"
    placeholder="Team name or ID"
    componentName="team"
    load={listTeams}
    renderTable={(teams) => (
      <DocumentTable<PlatformTeamRow> objects={teams} properties={PROPERTIES} />
    )}
  />
);
